module.exports = __webpack_public_path__ + "img/ybywzhfw_charact_3.08cf5617.svg";